<div class="recipient-cell-checkbox">
    <sol-checkbox class="recipient-checkbox" [checked]="params.node.isSelected()" (checkedChange)="onCheckboxChange($event)"></sol-checkbox>
    <span>{{ params.value }}</span>
</div>